module.exports = __webpack_public_path__ + "static/media/resultgavdos.6e629add.png";